export type Level = "low" | "average" | "high";

export function getOverviewConfig(knowledge: Level, activity: Level, speed: Level) {
  if (activity === "low") return {text: "Inactive", color: "#F57A47"};
  if (activity === "average") return {text: "Inconsistent", color: "#F5A623"};
  if (knowledge === "high" && speed === "high") return {text: "Exceptional Talent!", color: "#57B98F"};
  if (knowledge === "high") return {text: "Top Talent", color: "#57B98F"};
  if (speed === "high") return {text: "Rising Talent", color: "#57B98F"};
  if (speed === "average" && knowledge === "average") return {text: "Above Average", color: "#57B98F"};
  if (speed === "low" && knowledge === "low") return {text: "Below Average", color: "#F57A47"};
  return {text: "Average Learner", color: "#F5A623"};
}

export function levelColor(level: Level) {
  return level === "high" ? "#57B98F" : level === "average" ? "#F5A623" : "#F57A47";
}

export function levelLabel(level: Level) {
  return level === "high" ? "High" : level === "average" ? "Average" : "Low";
}

export const knowledgeLabelMap: Record<Level, string> = {high: "Excellent", average: "Average", low: "Low"};

export const capitalize = (s?: string) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : undefined);

/** Handles both legacy `string` values and future `{url, imageUrl?}` objects. */
export function extractUrl(value: string | {url: string; imageUrl?: string}): string {
  return typeof value === "string" ? value : value.url;
}
